import { render, staticRenderFns } from "./AnalyticsTab.vue?vue&type=template&id=bb2f0786&scoped=true"
import script from "./AnalyticsTab.vue?vue&type=script&lang=js"
export * from "./AnalyticsTab.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsTab.vue?vue&type=style&index=0&id=bb2f0786&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2f0786",
  null
  
)

export default component.exports